import axios from 'axios';

export const TEAM_USERS_RECEIVED = 'TEAM_USERS_RECEIVED';

const getTeamUsers = teamId => (
  (dispatch) => {
    axios.get(`/api/teams/${teamId}/users`)
      .then((response) => {
        dispatch({
          type: TEAM_USERS_RECEIVED,
          users: response.data.data,
          teamId,
        });
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      });
  }
);

export default getTeamUsers;
